// desk slice for redux toolkit
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// chunk of get desks
// /api/users/managers/
// GET

export const fetchDesks = createAsyncThunk(
    'desk/fetchDesks',
    async ({ token, limit = 10, offset = 0 }, { rejectWithValue }) => {
        try {
            const response = await fetch(`/api/desks/?limit=${limit}&offset=${offset}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${token}`, // Вставьте ваш токен аутентификации здесь
                },
            });
            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.message || 'Не удалось получить дески');
            }
            return data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    });
// add desk
// '/api/desks/add', 'POST', { name: desk }

export const deskSlice = createSlice({
    name: 'desk',
    initialState: {
        desks: [],
        total: 0,
        status: 'idle',
        currentPage: 1,
        deskPerPage: 10,
        error: null
    },
    reducers: {
        setDesk: (state, action) => {
            state.desks = [...state.desks, action.payload];
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDesks.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchDesks.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.desks = action.payload.desks;
                state.total = action.payload.total;
            })
            .addCase(fetchDesks.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    }
});

export const { setDesk } = deskSlice.actions;

export default deskSlice.reducer;